module.exports = __webpack_public_path__ + "static/media/mover_teclas.253c959d.svg";